export default {
  list: [],
  views: [],
  actions: [],
  isNew: false,
  item: {}
}